// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchMenu":"JT","selections":"KT","pillsDesktopSearchMenu":"LT"};